module.exports = __webpack_public_path__ + "static/media/powered-by-testive.f834adcc.png";